import { api } from '@shared/config/axiosConfig';
import { buildEndpoint } from '@shared/utils/buildEndpoint';
import { brandWithModelsFromDto, lineDetailsFromDto, vehicleByBrandModelLineFromDto, vehicleByFasecoldaFromDto, vehicleByPlateFromDto, vehicleFromDto, vehicleToDto } from '../mappers/vehiclesMapper';
import { mapPaginationResponse } from '@shared/utils/mapPaginationResponse';

const BASE_ENDPOINT = 'vehicle';

const buildServiceEndpoint = ({ id, action } = {}) => {
  return buildEndpoint(BASE_ENDPOINT, { id, action });
}

export const getVehicle = async (id) => {
  const endpoint = buildServiceEndpoint({ id });
  const response = await api.get(endpoint);
  return vehicleFromDto(response.data);
};

export const getVehicleByPlate = async (data) => {
  const params = {
    plate: data.plate,
  }

  const endpoint = buildServiceEndpoint({ action: 'by-plate' });
  const response = await api.get(endpoint, { params });
  return vehicleByPlateFromDto(response.data);
}

export const getVehicleByFasecolda = async (data) => {
  const params = {
    fasecolda_code: data.fasecoldaCode,
    ...(data.model && { model: data.model }),
  };

  const endpoint = buildServiceEndpoint({ action: 'by-fasecolda' });
  const response = await api.get(endpoint, { params });
  return vehicleByFasecoldaFromDto(response.data);
}

export const getVehicleByBrandModelLine = async (data) => {
  const params = {
    brand: data.brand,
    model: data.model,
    line: data.line,
  }

  const endpoint = buildServiceEndpoint({ action: 'by-brand-model-line' });
  const response = await api.get(endpoint, { params });
  return vehicleByBrandModelLineFromDto(response.data);
}

export const getBrands = async (data) => {
  const params = {
    search_text: data.searchText,
    page: data.page,
    page_size: data.pageSize,
  };

  const endpoint = buildServiceEndpoint({ action: 'brands' });
  const response = await api.get(endpoint, { params });
  return mapPaginationResponse(response, brandWithModelsFromDto);
};

export const getLines = async (data) => {
  const params = {
    brand: data.brand,
    model: data.model,
    search_text: data.searchText,
    page: data.page,
    page_size: data.pageSize,
  };

  const endpoint = buildServiceEndpoint({ action: 'lines' });
  const response = await api.get(endpoint, { params });
  return mapPaginationResponse(response, lineDetailsFromDto);
};

export const createVehicle = async (data) => {
  const payload = vehicleToDto(data);

  const endpoint = buildServiceEndpoint();
  const response = await api.post(endpoint, payload);
  return vehicleFromDto(response.data);
};

export const updateVehicle = async (id, data) => {
  const payload = vehicleToDto(data);

  const endpoint = buildServiceEndpoint({ id });
  const response = await api.put(endpoint, payload);
  return vehicleFromDto(response.data);
};
